@if (selectedRequest()) {
    <div class="card border border-light-subtle bg-body-tertiary rounded mb-3 shadow-sm">
        <!-- Cabecera de la Solicitud (Solo Escritorio) -->
        <div class="card-header py-3 d-none d-md-flex justify-content-between align-items-center bg-transparent border-bottom">
            <div>
                <h5 class="mb-0 fw-bold text-dark">
                    {{ getProcessName(selectedRequest()?.processSlug) }}
                </h5>
                <small class="text-muted">Solicitado el {{ selectedRequest()?.createdAt | date:'medium' }}</small>
            </div>
        </div>

        <!-- 1. Cabecera Ejecutiva: Datos del Socio -->
        <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-start gap-2">
                <div class="d-flex align-items-center gap-2">
                    <div class="transfer-user-avatar d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary fw-bold flex-shrink-0" style="width: 40px; height: 40px; font-size: 1.1rem;">
                        <i class="fas fa-user"></i>
                    </div>
                    <div>
                        <h6 class="mb-0 fw-bold text-dark">
                            {{ selectedRequest()?.party?.names || selectedRequest()?.partyName || 'Nombre de Socio' }}
                        </h6>
                        <small class="text-muted d-md-none">
                            Solicitado el {{ selectedRequest()?.createdAt | date:'dd/MM/yyyy HH:mm' }}
                        </small>
                    </div>
                </div>
                @if (selectedRequest()?.party?.rut) {
                    <span class="badge bg-secondary-subtle text-dark border font-monospace">
                        {{ selectedRequest()?.party?.rut }}
                    </span>
                }
            </div>

            <!-- Datos de Contacto Directo -->
            <div class="d-flex flex-wrap align-items-center gap-3 mt-2 pt-2 border-top border-light-subtle small text-muted">
                @if (selectedRequest()?.party?.mail) {
                    <div class="d-flex align-items-center gap-1">
                        <i class="fas fa-envelope text-primary opacity-75"></i>
                        <a [href]="'mailto:' + selectedRequest()?.party?.mail" class="text-decoration-none text-muted">
                            {{ selectedRequest()?.party?.mail }}
                        </a>
                    </div>
                }
                @if (selectedRequest()?.party?.mobileNumber) {
                    <div class="d-flex align-items-center gap-1">
                        <i class="fas fa-phone-alt text-success opacity-75"></i>
                        <a [href]="'tel:' + selectedRequest()?.party?.mobileNumber" class="text-decoration-none text-muted">
                            {{ selectedRequest()?.party?.mobileNumber }}
                        </a>
                    </div>
                }
            </div>
        </div>

        <!-- 2. Cuerpo: Flujo de Traspaso de Entidad -->
        <div class="card-body p-3">
            <div class="d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between gap-2">
                <!-- Entidad de Origen -->
                <div class="transfer-entity-card transfer-origin flex-fill p-3 rounded">
                    <span class="badge bg-danger-subtle text-danger border border-danger-subtle mb-1" style="font-size: 0.72rem;">
                        <i class="fas fa-sign-out-alt me-1"></i>Origen (Saliente)
                    </span>
                    <div class="fw-bold fs-14px text-dark mt-1">
                        {{ getEntityName(selectedRequest()?.entityCode) }}
                    </div>
                </div>

                <!-- Conector Visual (Flecha) -->
                <div class="d-flex align-items-center justify-content-center py-1 py-md-0 px-md-2">
                    <i class="fas fa-arrow-down d-md-none text-primary fs-5"></i>
                    <i class="fas fa-arrow-right d-none d-md-inline text-primary fs-5"></i>
                </div>

                <!-- Entidad de Destino -->
                <div class="transfer-entity-card transfer-dest flex-fill p-3 rounded">
                    <span class="badge bg-primary-subtle text-primary border border-primary-subtle mb-1" style="font-size: 0.72rem;">
                        <i class="fas fa-sign-in-alt me-1"></i>Destino (Receptora)
                    </span>
                    <div class="fw-bold fs-14px text-dark mt-1">
                        {{ getEntityName(selectedRequest()?.targetEntityCode) }}
                    </div>
                </div>
            </div>

            <!-- Acta / Voto -->
            <div class="d-flex align-items-center justify-content-between p-2 mt-3 rounded bg-body border border-light-subtle">
                <div class="d-flex align-items-center gap-2">
                    <i class="fas fa-file-signature text-primary"></i>
                    <span class="small text-muted text-uppercase fw-semibold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Acta / Voto</span>
                </div>
                <span class="fw-bold text-dark font-monospace small">
                    {{ documentGloss() || 'No especificado en la solicitud' }}
                </span>
            </div>
        </div>

        <!-- 3. Pie: Botones de Decisión -->
        @if (canApprove()) {
            <div class="card-footer bg-transparent p-3 border-top d-flex gap-2 justify-content-end">
                <button type="button" class="btn btn-outline-danger btn-sm flex-fill flex-md-grow-0 px-4" [disabled]="isProcessingApproval()" (click)="rejectRequest()">
                    <i class="fas fa-times me-1"></i> Rechazar
                </button>
                <button type="button" class="btn btn-success btn-sm flex-fill flex-md-grow-0 px-4" [disabled]="isProcessingApproval()" (click)="approveRequest()">
                    @if (isProcessingApproval()) {
                        <span class="spinner-border spinner-border-sm me-1"></span> Procesando...
                    } @else {
                        <i class="fas fa-check me-1"></i> Aprobar Transferencia
                    }
                </button>
            </div>
        }
    </div>

    <!-- Modal BPM para cargar documento si el paso lo requiere -->
    <app-step-approval-modal
        [request]="selectedRequest()"
        [isProcessing]="isProcessingApproval()"
        (confirmed)="onStepApprovalConfirmed($event)">
    </app-step-approval-modal>
}